<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/shop/getStation"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="站点名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="station_type" label="类型:" :label-width="60">
          <Select v-model="searchData.station_type">
            <Option value="">全部</Option>
            <Option v-for="(item,key) in station_types" :key="key" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
      </template>
    </pageTable>

    <stationDetailForm v-if="showStationEdit"
               :show-edit="showStationEdit"
               :station_id="editStationId"
               ref="editModel"
               @cancel-edit="showStationEdit=false"
    >
    </stationDetailForm>



  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import stationDetailForm from "./detail";
  import XLSX from 'xlsx'
  export default {
    name: "ty",
    components:{pageTable,stationDetailForm},
    data() {
      return {
        showStationEdit:false,
        editStationId:0,
        searchData: {
          gas_name: '',
          station_type:'',
        },
        station_types:[],
        tableColumn: [
          {title: 'ID',key: 'station_id',align: "center"},
          {title: '站点类型',key: 'station_type_name',align: "center"},
          /*{title: '用户',key: 'mobile',align: "center",render:(h,params)=>{
            return h('a',{on:{click:()=>{this.showUserDetailPage(params.row.user_id)}}},params.row.mobile || params.row.nick_name)
            }},*/
          {title: '油站名称',key: 'gas_name',align: "left"},
          {title: '地址',key: 'gas_address',align: "center",render:(h,params)=>{
              return  h('span',`${params.row.province_name}${params.row.city_name}${params.row.county_name}`)

              /*return h('Tooltip', {
                props: { placement: 'right' },
              }, [
                h('div', {
                  style: {
                    width: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }
                }, params.row.gas_address),
                h('span', {
                  slot: 'content',
                  style: {
                    whiteSpace: 'normal',
                    wordBreak: 'break-all'
                  }
                },params.row.gas_address)
              ])*/
            }},
         /* {title: '省',key: 'province_name',align: "center"},
          {title: '市',key: 'city_name',align: "center"},
          {title: '区',key: 'county_name',align: "center"},*/
          /*{title: '营业时间',align: "center",render:(h,params)=>{
            return h('div',`${params.row.work_start_time} - ${params.row.work_end_time}`)
            }},*/
          {title: '联系人',key:'contact_user',align: "center"},
          {title: '联系电话',key:'contact_mobile',align: "center"},
          {title: '价格',key: 'price',align: "center",},
          {title: '电话抽成',key: 'commission_mobile',align: "center"},
          {title: '状态',align: "center",render:(h,params)=>{
            let status = parseInt(params.row.gas_status)
              if (status === 1){
                return h('span','正常')
              }else if(status === 5){
                return h('span',{style:{color:'blue'}},'待审核')
              }else{
                return h('span',{style:{color:'red'}},'禁用')
              }
            }},
          {title: '操作',render:(h,params)=>{
            return h('Button',{props:{type:'primary',size:'small'},on:{click:()=>{this.showDetail(params.row.station_id)}}},'查看')
            }},
        ],
        tableData: [],
      }
    },
    methods: {
      showDetail(station_id){
        this.showStationEdit = true
        this.editStationId = station_id
      },
      exportData(){
        this.$commonFun.postProxy('admin/shop/export',this.searchData).then((res)=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`车生活站点.xlsx`)
        })
      },
      async initPage(){
        let data = await this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['stationType']})
        this.station_types = data.data.stationType
      },
    },
    mounted() {
      this.initPage()
    },
  }
</script>

<style scoped>

</style>
